import { render, staticRenderFns } from "./UsersResults.vue?vue&type=template&id=6559791f&"
import script from "./UsersResults.vue?vue&type=script&lang=js&"
export * from "./UsersResults.vue?vue&type=script&lang=js&"
import style0 from "./UsersResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports